﻿import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { DataService } from "../services/dataService";

@Injectable()
export class StaffAuthGuard implements CanActivate {

    constructor(private router: Router, private dataService: DataService) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (currentUser) {

            let isAccess = this.dataService.canAccessRemovalLink();
            
            if (currentUser.Security.search("vintJAXPortalAccess") >= 0 || currentUser.Security.search("vintJAXLimitedPortalAccess") >= 0) {
                //return true;

                if (state.url.indexOf("/dashboard/removalrequest") >= 0 ||
                    state.url.indexOf("/dashboard/createremovalrequest") >= 0) {
                    if (isAccess) {
                        return true;
                    } else {
                        this.router.navigate(["/dashboard/searchcase"], { queryParams: { returnUrl: state.url } });
                        return false;
                    }
                } else {
                    return true;
                }
            }
        }
        this.dataService.redirectionStatus = 4;
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
        return false;
    }
}

@Injectable()
export class AllAuthGuard implements CanActivate {

    constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (currentUser) {
            if (currentUser.Security.search("vintJAXPortalAccess") >= 0 || currentUser.Security.search("vintJAXParentPortalAccess") >= 0 || currentUser.Security.search("vintJAXLimitedPortalAccess") >= 0) {
                return true;
            }
        }
        this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
        return false;
    }
}

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (currentUser && currentUser.Token ) {
            return true;
        }
        this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
